module.exports = __webpack_public_path__ + "img/5-5.931bc40c.svg";